import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { loadBotPypes } from './load-bot-pypes';
import { Pype } from '../prostudio.api-service.types';
import { checkForErrors } from '../../utils';

export const deleteChannel = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ botPypes: Pype[] } | void> => {
  if (event.type !== 'deleteChannel') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  const { cb, pypeId, env } = event.payload;

  const mutation = {
    live: urqlGql.deletePypeLive,
    sandbox: urqlGql.deletePypeSandbox,
  };

  const deletePype = mutation[env];

  // urql resolves with an `errors` array instead of throwing, so without this
  // the invoke succeeds on a failed delete and `deletingChannelFlow.onDone`
  // fires "Channel deleted successfully" (and invalidates the channel-derived
  // caches) for a channel that is still there.
  const response = await deletePype({
    projectId,
    customerId: uniqueCustomerId,
    id: pypeId,
  });

  // Passed field-by-field rather than as the whole result: `deletePype` is a
  // union of the live and sandbox mutations, so the result is a union of two
  // `OperationResult`s and `checkForErrors` infers its generic from the first
  // member only, which the second then fails to satisfy.
  checkForErrors({ data: response.data, error: response.error });

  cb?.();

  const { botPypes } = await loadBotPypes(ctx, event);

  return { botPypes };
};
